import { render, staticRenderFns } from "./Document-delete.vue?vue&type=template&id=50fd2762"
import script from "./Document-delete.vue?vue&type=script&lang=js"
export * from "./Document-delete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports